
$( ".Collapsible__Button" ).each(function( index ) {
       $(this).click(function(){
            
            var control = $(this).attr('data-position');
            console.log(control);
            if(control == "false") {
                $(this).parent().find('.Collapsible__Inneron').slideDown();
                $(this).parent().find('.Collapsible__Inner').css({"height":"auto" , "visibility": "visible"});
                
                $(this).attr('data-position','true');
                $(this).find('.Collapsible__Plus').html("-");
            }
            else{
                $(this).parent().find('.Collapsible__Inneron').slideUp();
                $(this).parent().find('.Collapsible__Inner').css({"height":"0px" , "visibility": "hidden"});
                $(this).attr('data-position','false');
                $(this).find('.Collapsible__Plus').html("+");
            }

            
       });
  });




$( ".items___header" ).each(function( index ) {
       $(this).click(function(){
            
            var control = $(this).attr('data-position');
            console.log(control);
            if(control == "false") {
                $(".items___header").attr('data-position','false');
                $(".items___header").parent().find('.item___content').slideUp();
                $(".items___header").find(".items___icon").html("+");
                $(this).parent().find('.item___content').slideDown();
                $(this).find(".items___icon").html("-");
                $(this).attr('data-position','true');
                //$(this).find('.Collapsible__Plus').html("-");
            }
            else{
                $(this).parent().find('.item___content').slideUp();
                $(this).attr('data-position','false');
                $(this).find(".items___icon").html("+");
                //$(this).find('.Collapsible__Plus').html("+");
            }

            
       });
  });


$('.AnnouncementBar__Content').find('p').find('a').click(function(){
     window._klOnsite = window._klOnsite || []; 
     window._klOnsite.push(['openForm', 'VyeTfc']);
});



 


